import { useState } from 'react';
import type { FormEvent } from 'react';
import { useSession } from '../lib/session';
import { ApiError } from '../lib/api';

export function SignIn() {
  const { signIn } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Sign-in failed');
      setBusy(false);
    }
  }

  return (
    <div className="signin-shell">
      <form className="signin" onSubmit={submit}>
        <div className="brand-block">
          <strong>Rosabon Sentinel</strong>
          <span>Endpoint Security &amp; Device Management</span>
        </div>

        {error && <div className="notice error">{error}</div>}

        <label className="field">
          <span>Work email</span>
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button type="submit" disabled={busy || !email || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>

        <p className="footnote">
          Access is logged. Everything you do in this console &mdash; including viewing device data
          &mdash; is written to the audit trail and is visible to Internal Audit.
        </p>
      </form>
    </div>
  );
}
